import { render, staticRenderFns } from "./CompanyBadge.vue?vue&type=template&id=4322b6ae&"
import script from "./CompanyBadge.vue?vue&type=script&lang=js&"
export * from "./CompanyBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports